module.exports = "/_next/static/images/arrow_left-c7a7a6754aed1342dea9449b7274900b.svg";